import { useFeedbackRegionList } from '@/stores/LocaleStore';
import { ageGroupList, genderList, RACE } from '@/types/feedbackConst';
import { DEMOGRAPHIC_COLUMNS } from '@/types/filterKeyConst';
import { filterMap } from '@/utils/lazy';

export const useDemographicFilterMap = () => {
  const regionList = useFeedbackRegionList();
  const fieldOptions: StructuredFieldOptionMap = {
    [DEMOGRAPHIC_COLUMNS.LOCATION]: {
      columnKey: DEMOGRAPHIC_COLUMNS.LOCATION,
      columnName: 'Location',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: async (params) => {
          return filterMap(regionList, (region) => {
            const result = {
              columnKey: DEMOGRAPHIC_COLUMNS.LOCATION,
              filterKey: region.code,
              filterName: region.country,
              searchValue: region.country,
              useDepth: false,
              filterOptionNode: region.country,
            };

            if (params?.searchValue) {
              if (
                !region.country
                  .toLocaleLowerCase()
                  .includes(params?.searchValue?.toLocaleLowerCase())
              )
                return null;
            }

            return result;
          });
        },
      },
    },
    [DEMOGRAPHIC_COLUMNS.AGE]: {
      columnKey: DEMOGRAPHIC_COLUMNS.AGE,
      columnName: 'Age',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: async (params) => {
          return filterMap(ageGroupList, ([key, label]) => {
            if (params?.searchValue) {
              if (
                !label
                  .toLocaleLowerCase()
                  .includes(params?.searchValue?.toLocaleLowerCase())
              ) {
                return null;
              }
            }
            return {
              columnKey: DEMOGRAPHIC_COLUMNS.AGE,
              filterKey: key,
              filterName: label,
              searchValue: label,
              useDepth: false,
              filterOptionNode: label,
            };
          });
        },
      },
    },
    [DEMOGRAPHIC_COLUMNS.GENDER]: {
      columnKey: DEMOGRAPHIC_COLUMNS.GENDER,
      columnName: 'Gender',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: async (params) => {
          return filterMap(genderList, ([key, label]) => {
            if (params?.searchValue) {
              if (
                !label
                  .toLocaleLowerCase()
                  .includes(params?.searchValue?.toLocaleLowerCase())
              ) {
                return null;
              }
            }
            return {
              columnKey: DEMOGRAPHIC_COLUMNS.GENDER,
              filterKey: key,
              filterName: label,
              searchValue: label,
              useDepth: false,
              filterOptionNode: label,
            };
          });
        },
      },
    },
    [DEMOGRAPHIC_COLUMNS.RACE]: {
      columnKey: DEMOGRAPHIC_COLUMNS.RACE,
      columnName: 'Race',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: async (params) => {
          return filterMap(Object.values(RACE), (label) => {
            if (params?.searchValue) {
              if (
                !label
                  .toLocaleLowerCase()
                  .includes(params?.searchValue?.toLocaleLowerCase())
              ) {
                return null;
              }
            }
            return {
              columnKey: DEMOGRAPHIC_COLUMNS.RACE,
              filterKey: label,
              filterName: label,
              searchValue: label,
              useDepth: false,
              filterOptionNode: label,
            };
          });
        },
      },
    },
  };

  return fieldOptions;
};
